<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E6Gf0U/tc-custom/9781426862960.jpg?1700958272348" alt="This image is the cover for the book Hard to Handle, The Charmed and Dangerous Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard to Handle, The Charmed and Dangerous Series
      </h1>
      <p class="bookDescription body article font2">
        <p>She had secrets in her eyes and lies on her lips, and Detective Gabe Connally knew that Meghan Patterson would give him more than a few sleepless nights. Still, with her young nephew a valuable witness, Gabe had to pursue Meghan. And even without the case, it would be impossible to forget the vulnerable woman trying to protect her family....<br/><br/>While Meghan admired Gabe's persistence, she dared not let him get close enough to realize her nephew--her only remaining family--was psychic. Yet her own burning desire made it impossible to resist Gabe's persuasive ways....</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kylie Brant
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d1f99fe